'use client';

import React, { FC, useEffect, useRef } from 'react';

import { useAudioStore } from 'state/sfx/audioStore';
import { useMusicStore } from 'state/sfx/musicStore';
import useSoundsPreloadStore from 'state/soundsPreloadStore';

export interface MainMusicProps {}

const MainMusic: FC<MainMusicProps> = () => {
  const isAllowedAudio = useAudioStore(s => s.isAllowed);

  const landingRef = useRef<HTMLAudioElement | null>(null);
  const introRef = useRef<HTMLAudioElement | null>(null);
  const middleRef = useRef<HTMLAudioElement | null>(null);
  const endRef = useRef<HTMLAudioElement | null>(null);

  const landingSrc = useSoundsPreloadStore(
    s => s.library?.['main_music_landing']?.src
  );
  const introSrc = useSoundsPreloadStore(
    s => s.library?.['main_music_intro']?.src
  );
  const middleSrc = useSoundsPreloadStore(
    s => s.library?.['main_music_middle']?.src
  );
  const endSrc = useSoundsPreloadStore(s => s.library?.['main_music_end']?.src);

  const preloaded = useSoundsPreloadStore(s => s.preloaded);
  const initialPreloaded = useSoundsPreloadStore(s => s.initialPreloaded);
  const setAudio = useMusicStore(s => s.setAudio);

  useEffect(() => {
    if (initialPreloaded) {
      landingRef.current && setAudio('landingAudio', landingRef.current);
    }

    if (!preloaded) {
      return;
    }

    introRef.current && setAudio('introAudio', introRef.current);
    middleRef.current && setAudio('middleAudio', middleRef.current);
    endRef.current && setAudio('endAudio', endRef.current);
  }, [initialPreloaded, preloaded, setAudio]);

  return (
    <>
      <audio ref={landingRef} src={landingSrc} loop muted={!isAllowedAudio} />
      <audio ref={introRef} src={introSrc} loop muted={!isAllowedAudio} />
      <audio ref={middleRef} src={middleSrc} loop muted={!isAllowedAudio} />
      <audio ref={endRef} src={endSrc} loop muted={!isAllowedAudio} />
    </>
  );
};
export default MainMusic;
